import { AccountGetResponse, MLSID, isUndefined } from '@aloft/toolkit-shared';

import { ToolkitAccount } from '../controller/types.js';

export function apiAccountToToolkitAccount(apiAccount: AccountGetResponse): ToolkitAccount {
  const { body, createdAt, email, id, modifiedAt, isArchived, userType, isAdmin } = apiAccount;
  const {
    address,
    company,
    firstName,
    lastName,
    mlsIDs: mlsIDsIn,
    phone,
    userDefinedRole,
    license,
    isOnboardingComplete: apiIsOnboardingComplete,
    referredBy,
    mcKissockData,
  } = body;

  const mlsIDs = (mlsIDsIn ?? []) as MLSID[];
  const isOnboardingComplete = isUndefined(apiIsOnboardingComplete)
    ? true // Skip onboarding for users created before the onboarding feature was added
    : apiIsOnboardingComplete;

  return {
    isArchived,
    createdAt,
    email,
    id,
    modifiedAt,
    address: address ?? {},
    company,
    firstName,
    lastName,
    mlsIDs,
    defaultMLSID: mlsIDs?.[0],
    phone,
    userDefinedRole,
    licenseID: license?.id,
    licenseState: license?.state,
    isOnboardingComplete,
    referredBy,
    mcKissockData,
    userType,
    isAdmin,
  };
}
